import { create } from 'zustand';

/**
 * Remembers the last workspace the user was actually inside, so
 * account-level pages (e.g. /app/profile) and "back to app" links can
 * return to the RIGHT workspace instead of falling back to the first
 * one (or 404-ing). Persisted to localStorage so it survives reloads
 * and direct navigation to non-workspace routes.
 */
const STORAGE_KEY = 'plyez.lastWorkspaceId';

function readInitial(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

interface WorkspaceStore {
  lastWorkspaceId: string | null;
  setLastWorkspaceId: (id: string) => void;
}

export const useWorkspaceStore = create<WorkspaceStore>((set, get) => ({
  lastWorkspaceId: readInitial(),
  setLastWorkspaceId: (id: string) => {
    if (!id || get().lastWorkspaceId === id) return;
    if (typeof window !== 'undefined') {
      try {
        window.localStorage.setItem(STORAGE_KEY, id);
      } catch {
        /* private mode / quota — best-effort */
      }
    }
    set({ lastWorkspaceId: id });
  },
}));
